import React, {useEffect, useState, useRef} from 'react'
import { FloatButton } from "antd";
import CookieIcon from '@mui/icons-material/Cookie';

const FloatingCookieManager = ({ scrollRef }) => {
    const buttonRef = useRef();

    useEffect(() => {
        if(buttonRef?.current) {
            const describedbyAttributes = buttonRef.current.querySelectorAll('[aria-describedby^=":"]');
            describedbyAttributes?.forEach((el) => {
                el.removeAttribute('aria-describedby');
            });
        }
    }, [buttonRef.current]);

    const handleToggleCookieManager = () => {
        if (window.OneTrust && typeof window.OneTrust.ToggleInfoDisplay === 'function') {
            window.OneTrust.ToggleInfoDisplay();
        } else {
            console.error("OneTrust script not available.");
        }
    };

    return(
        <FloatButton
            id="edjin-help-link"
            ref={buttonRef}
            icon={<CookieIcon fontSize={"inherit"} />}
            onClick={handleToggleCookieManager}
            tooltip={"Manage Cookies"}
            aria-label={"Manage Cookies"}
            type={"primary"}
            style={{bottom: "80px", width: "50px", height: "50px", border: "5px solid rgba(255, 255,255, 0.6)"}}
        />
    )
}

export default FloatingCookieManager;